//#region ../r-html/dist/helpers/fn.js
function safeCallback(callback, ...args) {
	try {
		return callback?.(...args);
	} catch (e) {
		console.error(e);
	}
}
var queueMicrotaskFallback = (callback) => {
	Promise.resolve().then(callback);
};
var asap = queueMicrotask ?? queueMicrotaskFallback;
//#endregion
export { asap, safeCallback };
